module.exports = __webpack_public_path__ + "img/client-logos.f7b60585.png";